
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/partnerships/teal",
      function () {
        return require("private-next-pages/docs/transactions/partnerships/teal.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/partnerships/teal"])
      });
    }
  